export default __webpack_public_path__ + "static/media/founder.ef85a723.png";